import React, { useEffect, useRef, useState } from 'react'
// Slices from redux --------------------------------------------------------------------------
import { fetchDepartmentData, initDepartState } from "../../redux/slices/departmentSlice";
import { fetchDesignationList, initDesigState } from "../../redux/slices/designationSlice";
import { fetchData as fetchShiftList, initShiftState } from "../../redux/slices/shiftsSlice.js";
import { employeeAttType, initAttTypeState } from "../../redux/slices/attendanceSlice.js";
import { fetchHolidayData, initFetchHolidayState } from "../../redux/slices/holidaySlice.js";
import { initFetchLeaveState, fetchLeaveData } from "../../redux/slices/leaveSlice.js";
import { fetchBranchData, initBranchState } from "../../redux/slices/branchSlice";
import { commonGetDataOne, initCommonState } from "../../redux/slices/commonSlice";
// Config API's path --------------------------------------------------------------------------
import {
    getMyBreaksListPath,
    getAttendanceModulePath,
    getHolidayMainPath,
    getLeaveMain
} from "../../services/config";
// Redux store --------------------------------------------------------------------------------
import { useDispatch } from 'react-redux';
// Services that required for components ------------------------------------------------------
import { useSelect } from '../../services/commonServices.js';
import { Form } from 'react-bootstrap';
// Icons --------------------------------------------------------------------------------------
import { AngleUp, ArrowRightLong, ArrowRotateRight, ArrowUpLong, Bars, Bell, BookOpen, Calculator, CalendarAlt, Check, CircleExclamation, CircleInfo, CircleXmark, ClipboardList, Clock, CommentDots, Cross, Crown, DotFill, Download, EyeIcon, FileArrowUp, FileCircleXmark, FileLines, Filter, Flag, Hammer, House, IdCard, NoteSticky, PaperPlane, Pause, PencilLine, Percent, Play, Receipt, RupeeSign, Search, ShieldHalved, TriangleExclamation, Upload, UserLarge, UserTie } from '../../components/icons/Icons'

const user = JSON.parse(localStorage.getItem("user_data")) || {}

// const dispatch = useDispatch()

// dispatch(fetchBranchData(user.user_id));
// dispatch(fetchDepartmentData(user.user_id));
// dispatch(fetchDesignationList(user.user_id));
// dispatch(fetchShiftList(user.user_id))
// dispatch(commonGetDataOne(`${getMyBreaksListPath}${user?.user_id}`));

// dispatch(getEmployeeDataOne(getRMTeamLeaderListPath("", user.user_id)))
// dispatch(getEmployeeDataTwo(getRMManagerListPath("", user.user_id)))
// dispatch(getEmployeeDataThree(getRMHeadListPath("", user.user_id)))

// dispatch(employeeAttType(`${getAttendanceModulePath}${user.user_id}`))
// dispatch(fetchHolidayData(`${getHolidayMainPath}${user.user_id}`))
// dispatch(fetchLeaveData(`${getLeaveMain}${user.user_id}`))


//   const state = useSelect((state) => state.common);
//   const branchState = useSelector((state) => state.branch);
//   const employeeState = useSelector((state) => state.employee);
//   const designationStore = useSelector((state) => state.designation);
//   const departmentState = useSelector((state) => state.department);
//   const shiftStore = useSelector((state) => state.shift);
//   const employeeStore = useSelector((state) => state.employee);
//   const attendanceStore = useSelector((state) => state.attendance)
//   const holidayStore = useSelector((state) => state.holiday)
//   const leaveStore = useSelector((state) => state.leave). All, Requested, Approved, Rejected, Hold

// All, Requested, Approved, Rejected, Hold          

export const BranchList = ({ name, value, onChange }) => {
    const dispatch = useDispatch()
    const branchState = useSelect("branch");

    const [branchList, seBranchList] = useState([])

    useEffect(() => {
        dispatch(fetchBranchData(user.user_id));
    }, [])

    useEffect(() => {
        if (branchState.brnGetSuccess) {
            seBranchList(branchState.brnGetData || [])
        }
    }, [branchState])

    return (
        <Form.Select name={name} value={value} onChange={onChange} className="universal-input" style={{ width: "150px" }}>
            <option value={""}>All Location</option>
            {
                branchList.map((item) => { return <option key={item.branchId} value={item.branchId}>{item.branch_name}</option> })
            }
        </Form.Select>
    )
}

export const DepartmentList = ({ name, value, onChange }) => {
    const dispatch = useDispatch()
    const depStore = useSelect("department")

    const [departmentList, setDepartmentList] = useState([])

    useEffect(() => {
        dispatch(fetchDepartmentData(user.user_id));
    }, [])

    useEffect(() => {
        if (depStore.depGetSuccess) {
            setDepartmentList(depStore.depGetData || [])
        }
    }, [depStore])

    return (
        <Form.Select name={name} value={value} onChange={onChange} className="universal-input" style={{ width: "180px" }}>
            <option value={""}>Select Department</option>
            {
                departmentList.map((item) => { return <option key={item.departmentId}>{item.department_name}</option> })
            }
        </Form.Select>
    )
}

export const RegimetList = ({ name, value, onChange }) => {
    return (
        <Form.Select name={name} value={value} onChange={onChange} className="universal-input border-radius-8px" style={{ width: "150px" }}>
            <option value={"all"} key={0}>All Regime</option>
            <option value="new" key={1}>New Regime</option>
            <option value="old" key={2}>Old Regime</option>
        </Form.Select>
    )
}

export const FinancialYear = ({ selectedYear, setSelectedYear }) => {
    const rootRef = useRef(null);
    const [years, setYears] = useState([]);
    const [open, setOpen] = useState(false);

    // generate FY list and set default selected as current financial year (Apr-Mar logic)
    useEffect(() => {
        const now = new Date();
        const month = now.getMonth() + 1; // 1..12
        const year = now.getFullYear();

        // determine current FY (India style Apr-Mar)
        const currentFyStart = month >= 4 ? year : year - 1;
        const currentFyValue = `${currentFyStart}-${(currentFyStart + 1)
            .toString()
            .slice(-2)}`;

        // create range: currentFyStart - 3 .. currentFyStart + 1 (adjust as needed)
        const temp = [];
        for (let i = currentFyStart - 3; i <= currentFyStart + 1; i++) {
            const value = `${i}-${(i + 1).toString().slice(-2)}`; // "2023-24"
            const label = `FY ${value}`; // "FY 2023-24"
            temp.push({ label, value });
        }

        // newest first (descending)
        const ordered = temp.reverse();
        setYears(ordered);
        // set selected to the computed current FY value if present, else first item
        const found = ordered.find((y) => y.value === currentFyValue);
        setSelectedYear(found ? found.value : ordered[0].value);
    }, []);
    // toggle
    const toggleDropdown = () => setOpen((o) => !o);

    // close on outside click or ESC
        useEffect(() => {
            const onDocClick = (e) => {
                if (!rootRef.current) return;
                if (!rootRef.current.contains(e.target)) {
                    setOpen(false);
                }
            };
            const onEsc = (e) => {
                if (e.key === "Escape") setOpen(false);
            };
    
            if (open) {
                document.addEventListener("mousedown", onDocClick);
                document.addEventListener("touchstart", onDocClick);
                document.addEventListener("keydown", onEsc);
            } else {
                document.removeEventListener("mousedown", onDocClick);
                document.removeEventListener("touchstart", onDocClick);
                document.removeEventListener("keydown", onEsc);
            }
    
            // cleanup on unmount
            return () => {
                document.removeEventListener("mousedown", onDocClick);
                document.removeEventListener("touchstart", onDocClick);
                document.removeEventListener("keydown", onEsc);
            };
        }, [open]);

    // select click
    const handleSelect = (value) => {
        setSelectedYear(value);
        setOpen(false);
    };

    return <div className="fy-dropdown" ref={rootRef}>
        <button
            type="button"
            className="universal-input border-radius-8px no-wrap-text"
            onClick={toggleDropdown}
            aria-expanded={open}
            aria-haspopup="listbox"
        >
            <span className="fy-label">
                {selectedYear ? `FY ${selectedYear}` : "Select FY"}
            </span>
            <span className={`arrow ${open ? "up" : ""}`} style={{ position: "relative", top: open ? "" : "3px" }}><AngleUp /> </span>
        </button>

        {open && (
            <ul className="fy-menu" role="listbox" aria-label="Financial Years">
                {years.map((y) => (
                    <li
                        key={y.value}
                        role="option"
                        aria-selected={selectedYear === y.value}
                        className={`fy-item ${selectedYear === y.value ? "active" : ""}`}
                        onClick={(e) => { e.stopPropagation(); handleSelect(y.value); }}
                    >
                        {y.label}
                    </li>
                ))}
            </ul>
        )}
    </div>
}

export const AllStatusList = ({ name, value, onChange }) => {
    return (
        <Form.Select name={name} value={value} onChange={onChange} className="universal-input border-radius-8px" style={{ width: "150px" }}>
            <option value={"all"} key={0}>All Status</option>
            <option value="requested" key={1}>Requested</option>
            <option value="approved" key={2}>Approved</option>
            <option value="rejected" key={2}>Rejected</option>
            <option value="hold" key={2}>Hold</option>
        </Form.Select>
    )
}

export const PageList = ({ name, value, onChange }) => {
    return (
        <Form.Select name={name} value={value} onChange={onChange} className="universal-input border-radius-8px" style={{ width: "150px" }}>
            <option value={"10"} key={0}>10</option>
            <option value="20" key={1}>20</option>
            <option value="50" key={2}>50</option>
            <option value="100" key={3}>100</option>
        </Form.Select>
    )
}
